import { useShelvingStore, useStoreSystem } from "../store";
import shallow from "zustand/shallow";

export const useCurrent = () => {
    const { currentSection, setCurrentSection, currentEditItem, currentSectionId, setCurrentEditItem, setCurrentSectionId } = useStoreSystem((state) => ({
        currentSection: state.currentSection,
        setCurrentSection: state.setCurrentSection,
        currentEditItem: state.currentEditItem,
        currentSectionId: state.currentSectionId,
        setCurrentEditItem: state.setCurrentEditItem,
        setCurrentSectionId: state.setCurrentSectionId,
    }), shallow);

    const deleteCurrentEditItem = useShelvingStore((state) => state.deleteCurrentEditItem, shallow);  //TODO переделать на функцию которая принимает id или еще что и удаляет объект

    return {
        currentSection,
        setCurrentSection,
        currentEditItem,
        setCurrentEditItem,
        currentSectionId,
        setCurrentSectionId,
        deleteCurrentEditItem
    };
};
